/**
 * MaterialCard — featured material card.
 * Shared by chapters 2727, 2728 (CX-2725 §3). Also reused for the interactive
 * hotspot ↔ material card pairing that appears in both 2727 and 2728.
 */

import { ContentLink } from "components/content-link";
import type { ChapterMaterialCard } from "../chapter.types";
import { CMF_GUIDE_DEFAULT_IMAGE } from "../cmfGuideData";
import "./MaterialCard.css";

interface MaterialCardProps {
  card: ChapterMaterialCard;
}

export const MaterialCard = ({ card }: MaterialCardProps) => (
  <article className="material-card">
    {card.image && (
      <div className="material-card__image-wrap">
        <img
          src={card.image}
          alt={card.title}
          className="material-card__image"
          loading="lazy"
          draggable={false}
          onError={(e) => {
            const img = e.currentTarget as HTMLImageElement;
            if (img.src.endsWith(CMF_GUIDE_DEFAULT_IMAGE)) return;
            img.src = CMF_GUIDE_DEFAULT_IMAGE;
          }}
        />
      </div>
    )}
    <div className="material-card__body">
      <h3 className="material-card__title">{card.title}</h3>
      <p className="material-card__description">{card.description}</p>
      {card.tags && card.tags.length > 0 && (
        <div className="material-card__tags">
          {card.tags.map((tag) => (
            <span key={tag} className="material-card__tag">
              {tag}
            </span>
          ))}
        </div>
      )}
      {card.link && <ContentLink {...card.link} />}
    </div>
  </article>
);
